var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import styled from "styled-components";
import BaseCard from "../../card";
export var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n  position: relative;\n"], ["\n  height: 100%;\n  position: relative;\n"])));
export var Card = styled(BaseCard)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: 21rem;\n\n  a {\n    text-decoration: none;\n  }\n"], ["\n  height: 21rem;\n\n  a {\n    text-decoration: none;\n  }\n"])));
export var Overlay = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 0.3rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n"], ["\n  width: 100%;\n  height: 100%;\n  background: rgba(255, 255, 255, 0.8);\n  border-radius: 0.3rem;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 10;\n"])));
export var Footer = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n"], ["\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;